module.exports = __webpack_public_path__ + "dojo-technologies.azf8E4qb.svg";